module.exports = "../images/authentication.png?d8438664af26a3b351d25d47b567f220";